import { sortBy } from 'remeda'

import { TokenSymbol } from '@/domain/types/TokenSymbol'

const SAVINGS_TOKENS_ORDER = [
  TokenSymbol('spUSDC'),
  TokenSymbol('spUSDT'),
  TokenSymbol('sUSDS'),
  TokenSymbol('spETH'),
  TokenSymbol('spPYUSD'),
  TokenSymbol('sUSDC'),
  TokenSymbol('sDAI'),
  TokenSymbol('stUSDS'),
]

export function sortSavingsAccounts<T extends { savingsToken: TokenSymbol }>(accounts: T[]): T[] {
  return sortBy(accounts, (account) => {
    const index = SAVINGS_TOKENS_ORDER.indexOf(account.savingsToken)
    return index === -1 ? SAVINGS_TOKENS_ORDER.length : index
  })
}
